import { useMemo } from 'react';
import { useGlobalSettingsContext } from 'contexts/GlobalSettingsContext';
import { FINDING_STATUS } from "views/Findings/Constants";
import { difference } from 'lodash';

export default function useResolvedFindingStatus() {
    const { mitigatedStatus, disabledFindingStatus } = useGlobalSettingsContext();
    const resolvedStatus = useMemo(() => {
        let statuses = [];
        statuses = [...mitigatedStatus, FINDING_STATUS.MITIGATED];
        statuses = difference(statuses, disabledFindingStatus)
        
        return statuses;
    }, [mitigatedStatus, disabledFindingStatus]);

    return resolvedStatus;
}